<div class="flex items-center gap-2">
	@if (viewModel_()?.intakeStatusDisplay; as intakeStatus) {
		@if (intakeStatus.icon) {
			<i-tabler
				class="h-5 w-5"
				[name]="intakeStatus.icon"
				[class]="intakeStatus.iconClasses"
			/>
		}
		<div class="font-medium text-sm text-gray-500 text-nowrap">
			{{ intakeStatus.label }}
		</div>
	}
</div>
